import axios from "axios";
import { useLogout } from "hooks/useLogout";
import toastr from "toastr";
//pass new generated access token here




toastr.options = {
  positionClass: "toast-top-right",
  timeOut: 5000,
  extendedTimeOut: 1000,
  closeButton: true,
  debug: false,
  progressBar: true,
  preventDuplicates: true,
  newestOnTop: true,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
  showDuration: 300,
  hideDuration: 1000
};
//apply base url for axios
const API_URL = process.env.REACT_APP_API_URL

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  withXSRFToken: true
});

axiosApi.defaults.withCredentials = true;
// axiosApi.defaults.headers.common["Authorization"] = localStorage.getItem("token");
axiosApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")  

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  

  return config;
}, (error) => {
  return Promise.reject(error);
});

axiosApi.interceptors.response.use(
  response => {

    if (response.status === 201 && response.data.message) {
      toastr.success(response.data.message);
    }
    return response;
  },
  error => {
    // Check if the error response exists and is a 400, 401, or 500 error
    if (error.response && (error.response.status === 400 || error.response.status === 401 || error.response.status === 500)) {
      let message;
      if (error.response.status === 400) {
        message = error.response.data.message || "A 400 error occurred";
      } else if (error.response.status === 401) {
        console.log("Unauthorized access");
        localStorage.clear();
        window.location.href = "/login";
        message = "Unauthorized access";
      } else if (error.response.status === 500) {
        message = "Something went wrong";
      }
      toastr.error(message);
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data);
}

export async function post(url, data, config = {}) {
  const isFormData = data instanceof FormData;

  return axiosApi
    // .post(url, { ...data }, { ...config })
    // .then(response => response.data);
    .post(url, data, {
      ...config,
      // No need to set Content-Type; Axios will handle it
      headers: {
        ...config.headers,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }) // Optional: Set Content-Type for non-FormData
      }
    })
    .then(response => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data);
}
